import { Outlet, useNavigate } from 'react-router-dom'
import { Row, Col, Button, BreadCrumb, Card } from './ot'
import { useTranslation } from 'react-i18next'
const Mainlayout = ({
    breadCrumbMode = true,  //頁面導覽列開關控制
    previousButtonMode = false,  //頁面右上、右下上一頁開關控制
    ...props
}) => {
    const navigate = useNavigate()
    const { t, i18n } = useTranslation()
    return <>
        <Row gutter={[16, 16]}>
            <Col span={24}>
                {breadCrumbMode &&
                    <Row justify={'space-between'}>
                        <Col>
                            <BreadCrumb />
                        </Col>
                        {previousButtonMode &&
                            <Col>
                                <Button
                                    size='small'
                                    onClick={() => navigate(-1)}
                                >{t('previous')}</Button>
                            </Col>
                        }
                    </Row>
                }
            </Col>
            <Col span={24}>
                {!props?.noCard && <Card>
                    <Outlet />
                </Card>}
                {!!props?.noCard &&
                    <Outlet />
                }
            </Col>
            <Col span={24}>
                <Row justify={'end'}>
                    {previousButtonMode &&
                        <Col>
                            <Button
                                size='small'
                                onClick={() => navigate(-1)}
                            >{t('previous')}</Button>
                        </Col>
                    }
                </Row>
            </Col>
        </Row>
    </>
}
export default Mainlayout